import {get, post, put} from "../../Http"
let baseUrl = "api-tax-personal-income-server"

//   合计及填写人数查询
function totalTax(query){
  return post(`/${baseUrl}/taxCalculation/findTotalTaxCalculation`, query)
}
//综合所得申报   工资查询
function findWageById(query){
  return post(`${baseUrl}/wage/findWageById`, query)
}
// //综合所得申报  工资新增
function addSalry(query) {
  return post(`/${baseUrl}/wage/addWage`,query)
}
// //综合所得申报  工资列表查询
function wageList(query) {
  return post(`${baseUrl}/wage/findWages`,query)
}
// //综合所得申报  工资详情
function detailSalry(query) {
  return post(`/${baseUrl}/wage/findWageById`,query)
}
// 复制上期所有工资信息生成本期工资信息
function copyLastMonth(query) {
  return post(`/${baseUrl}/wage/copyWage`,query)
}
//预填专项附加扣除
function  preFilling(query){
  return post(`/${baseUrl}/wage/preFilling`,query)
}
//删除正常工资薪金
function deleateSalry(query) {
  return post(`/${baseUrl}/wage/deleteWageByIds`,query)
}
//根据人员查询信息工资
function detailByUser(query) {
  return post(`/${baseUrl}/wage/findWageByUser`,query)
}
//劳务报酬 新增
function addLabour(query){
  return post(`/${baseUrl}/general-labour/addGeneralLabour`, query)
}
// //劳务报酬删除
function delateLabour(query) {
  return post(`/${baseUrl}/general-labour/deleteGeneralLabourById`,query)
}
//劳务报酬列表
function labourList(query) {
  return post(`/${baseUrl}/general-labour/findGeneralLabours`,query)
}
//劳务报酬更新id
 function updataLabourId(query) {
  return post(`/${baseUrl}/general-labour/updateWageById`,query)
}
// //劳务报酬 根据id查询劳务报酬明细信息
function detailLabour(query) {
  return post(`/${baseUrl}/general-labour/findGeneralLabourDetail`,query)
}
///根据人员id查询劳务报酬（一般劳务）信息
function LabourByUser(query) {
  return post(`/${baseUrl}/general-labour/findGeneralLabourByUser`,query)
}
//清除数据
function salaryReset(query) {
  return post(`/${baseUrl}/wage/cleanWages`,query)
}
//清除数据
function labourReset(query) {
  return post(`/${baseUrl}/general-labour/cleanGens`,query)
}
// 添加全年一次性奖金收入
function addBonusIncome(query) {
  return post(`/${baseUrl}/bonus-income/addBonusIncome`,query)
}
// 收入及填写页面--清除数据
function cleanBonus(query) {
  return post(`/${baseUrl}/bonus-income/cleanBonus`,query)
}
///奖金人员信息查询
function findBonusIncomeByUser(query) {
  return post(`/${baseUrl}/bonus-income/findBonusIncomeByUser`,query)
}
// 批量删除全年一次性奖金收入
function delateBonus(query) {
  return post(`/${baseUrl}/bonus-income/deleteBonusIncomeByIds`,query)
}
// 根据id查询奖金收入明细信息
function idDetailBonus(query) {
  return post(`/${baseUrl}/bonus-income/findBonusIncomeDetail`,query)
}
//全年一次性奖金收入列表
function bonusList(query) {
  return post(`/${baseUrl}/bonus-income/findBonusIncomePage`,query)
}
// 添加稿酬收入
function addRemuneration(query) {
  return post(`/${baseUrl}/remuneration/addRemuneration`,query)
}
// 收入及填写页面--清除数据
function cleanRemunerations(query) {
  return post(`/${baseUrl}/remuneration/cleanRemunerations`,query)
}
// 特许权使用费所得--清除数据
function cleanConcessions(query) {
  return post(`/${baseUrl}/concessions/clear`,query)
}
// 批量删除稿酬收入
function delateRemun(query) {
  return post(`/${baseUrl}/remuneration/deleteRemunerationByIds`,query)
}
// 根据id查询稿酬明细信息
function detailRemun(query) {
  return post(`/${baseUrl}/remuneration/findRemunerationDetail`,query)
}
// 稿酬收入列表
function RemunList(query) {
  return post(`/${baseUrl}/remuneration/findRemunerationPage`,query)
}
// 特许权使用费列表
function concessionsPage(query) {
  return post(`/${baseUrl}/concessions/page`,query)
}
// 特许权使用费保存
function concessionsSave(query) {
  return post(`/${baseUrl}/concessions/save`,query)
}
// 特许权使用费详情
function concessionsDetail(query) {
  return post(`/${baseUrl}/concessions/detail`,query)
}
// 特许权使用费删除
function concessionsDel(query) {
  return post(`/${baseUrl}/concessions/del`,query)
}
export default {
  addBonusIncome,
  cleanBonus,
  delateBonus,
  idDetailBonus,
  bonusList,
  addRemuneration,
  cleanRemunerations,
  cleanConcessions,
  findBonusIncomeByUser,
  delateRemun,
  detailRemun,
  RemunList,
  totalTax,
  findWageById,
  addSalry,
  wageList,
  detailSalry,
  deleateSalry,
  detailByUser,
  addLabour,
  delateLabour,
  labourList,
  updataLabourId,
  detailLabour,
  preFilling,
  LabourByUser,
  salaryReset,
  labourReset,
  copyLastMonth,
  concessionsPage,
  concessionsSave,
  concessionsDetail,
  concessionsDel

}



// WEBPACK FOOTER //
// ./src/api/consolidated-income-tax-statement/incomeWrite/index.js